import env from '../config/env';
import service from '../api/branch.service';
import permission from '../api/permissions.service';

//constants
const data = {
    securityPermission: null,
    societies: [],
    cEntities: [],
    branches: [],
    branchAdd: null,
    responseBranch: null,
    noPermittedBranch: '',
    errorResponse: ''
}
//types
const SECURITY_PERMISSIONS = 'SECURITY_PERMISSIONS';
const LIST_SOCIETY = 'LIST_SOCIETY';
const LOAD_COLLECTING_ENTITIES = 'LOAD_COLLECTING_ENTITIES';

const LIST_BRANCH = 'LIST_BRANCH';
const LIST_BRANCH_ERROR = 'LIST_BRANCH_ERROR';
const ADD_BRANCH = 'ADD_BRANCH';
const UPDATE_BRANCH = 'UPDATE_BRANCH';
const DELETE_BRANCH = 'DELETE_BRANCH';
const ERROR_RESPONSE = 'ERROR_RESPONSE';

//reducer
export default function branchReducer(state = data, action) {
    switch (action.type) {
        case SECURITY_PERMISSIONS:
            return { ...state, securityPermission: action.payload };
        case LIST_SOCIETY:
            return { ...state, societies: action.payload };
        case LOAD_COLLECTING_ENTITIES:
            return { ...state, cEntities: action.payload };
        case LIST_BRANCH:
            return { ...state, branches: action.payload };
        case ADD_BRANCH:
            return { ...state, branchAdd: action.payload };
        case LIST_BRANCH_ERROR:
            return { ...state, noPermittedBranch: action.payload };
        case ERROR_RESPONSE:
            return { ...state, errorResponse: action.payload };
        default:
            return { ...state };
    }
}

export const getPermissions = (username, action) => async (dispatch) => {
    const response = await permission.validPermission(
        env.transaction.branch,
        username,
        env.app.systemCode, action);
    dispatch({
        type: SECURITY_PERMISSIONS,
        payload: response
    });
    return response;
}

export const findSocieties = (country) => async (dispatch) => {
    const response = await service.getSocieties(country).then((r) => { return r.data });
    let data = [];
    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.country.code,
                    label: '[' + element.code + '] ' + element.name.toUpperCase(),
                });
            });
        } else {
            dispatch({
                type: ERROR_RESPONSE,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_SOCIETY,
        payload: data
    });
}

export const findBySocieties = (society) => async (dispatch) => {
    const response = await service.findBySociety(society).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    let data = [];
    if (response.code !== undefined) {
        dispatch({
            type: ERROR_RESPONSE,
            payload: response
        });
        dispatch({
            type: LOAD_COLLECTING_ENTITIES,
            payload: []
        });
    } else {
        response.forEach((element) => {
            data.push({
                value: element.id,
                label:  element.name.toUpperCase()+' | '+ element.code ,
            });
        });
        dispatch({
            type: ERROR_RESPONSE,
            payload: ''
        });
        dispatch({
            type: LOAD_COLLECTING_ENTITIES,
            payload: data
        });
    }

}

/*export const findBranch = (user,society,entity) => async (dispatch) => {
    
    const response = await service.getBranches(society,entity).then((r) => { return r.data });
    let data = [];


    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.id,
                    label: element.name.toUpperCase(),
                });
            });
        } else {
            dispatch({
                type: LIST_BRANCH_ERROR,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_BRANCH,
        payload: data
    });
}*/

export const findRawBranches = (entity) => async (dispatch) => {
    const response = await service.getBranches(entity).then((r) => { return r.data });
    dispatch({
        type: LIST_BRANCH,
        payload: response
    });
    return response;
}

export const saveBranch = (branchData) => async (dispatch) => {
    const response = await service.saveBranch(branchData).then((r) => { return r });
    dispatch({
        type: ADD_BRANCH,
        payload: response
    });
    return response;
}
export const updateBranch = (branchData) => async (dispatch) => {
    const response = await service.updateBranch(branchData).then((r) => { return r });

    dispatch({
        type: UPDATE_BRANCH,
        payload: response
    });
    return response;
}

export const deleteBranch = (branches) => async (dispatch) => {
    const response = await service.deleteBranch(branches).then((r) => { return r });

    dispatch({
        type: DELETE_BRANCH,
        payload: response
    });
    return response;
}